import type { ContactsView } from '@/pages/StaffContactsView.types'
import type { StaffArea } from '@/pages/staffNavigation'

export function staffAreaForView(view: ContactsView): StaffArea {
  const mappedArea = staffAreaByKind[view.kind]
  if (mappedArea) return mappedArea

  switch (view.kind) {
    case 'members':
      return 'members'
    case 'organization-memberships':
      return 'organization-memberships'
    case 'renewal-pipeline':
      return 'renewal-pipeline'
    case 'engagement':
      return 'engagement'
    case 'person-profile':
      return view.origin === 'members' ? 'members' : 'contacts'
    case 'duplicates':
      return 'contact-duplicates'
    case 'import':
      return 'contact-import'
    case 'communication-audiences':
    case 'communication-group-detail':
    case 'communication-segment-new':
    case 'communication-segment-detail':
      return 'communication-audiences'
    default:
      return 'contacts'
  }
}

const staffAreaByKind: Partial<Record<ContactsView['kind'], StaffArea>> = {
  'event-registrations': 'event-registrations',
  connections: 'connections',
  'unmatched-items': 'unmatched-items',
  'connection-detail': 'connections',
  chapters: 'chapters',
  'chapter-detail': 'chapters',
  'events-list': 'events',
  'courses-list': 'courses',
  'enrolment-import': 'courses',
  'course-new': 'courses',
  'course-edit': 'courses',
  'course-detail': 'courses',
  'event-new': 'events',
  'event-detail': 'events',
  'event-check-in': 'events',
  'custom-fields': 'custom-fields',
  'membership-levels': 'membership-levels',
  'renewal-settings': 'renewal-settings',
  'renewal-arming-review': 'renewal-settings',
  'payment-settings': 'payment-settings',
  'finance-settings': 'finance-settings',
  'tax-settings': 'tax-settings',
  'discount-codes': 'discount-codes',
  'discount-code-detail': 'discount-codes',
  'accounting-settings': 'accounting-settings',
  'email-identity-settings': 'email-identity-settings',
  'system-email-settings': 'system-email-settings',
  'system-email-templates': 'system-email-templates',
  'engagement-weights': 'engagement-weights',
  'admin-directory-settings': 'admin-directory-settings',
  'admin-directory-preview': 'admin-directory-settings',
  'organization-dashboard-setting': 'organization-dashboard-setting',
  'credit-unit-settings': 'credit-unit-settings',
  seats: 'seats',
  'communication-blasts': 'communication-blasts',
  'communication-blast-report': 'communication-blasts',
  'finance-overview': 'finance-overview',
  'financial-history': 'financial-history',
  'finance-invoices': 'finance-invoices',
  'invoice-detail': 'finance-invoices',
  'finance-autopay-recovery': 'finance-autopay-recovery',
  'finance-tax-report': 'finance-tax-report',
  'finance-income-report': 'finance-income-report',
  'finance-collections-report': 'finance-collections-report',
  'finance-membership-report': 'finance-membership-report',
  'finance-aging-report': 'finance-aging-report',
  'finance-recognition-schedule': 'finance-recognition-schedule',
  'finance-payouts': 'finance-payouts',
  'communication-email-log': 'communication-email-log',
  'finance-unreachable-members': 'finance-unreachable-members',
  'finance-donations': 'finance-donations',
  'finance-campaigns': 'finance-campaigns',
  'finance-campaign-detail': 'finance-donations',
  'finance-admin-campaign-detail': 'finance-campaigns',
}
